/*=========================================================================================
  File Name: moduleCountryMutations.js
  Description: Country Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_ITEM(state, item) {
    state.Brokers.unshift(item)
  },
  SET_Brokers(state, Brokers) {
    debugger;
    try {
      
      state.Brokers = Brokers;
      
    } catch (error) {
      console.error("Failed to parse Brokers data JSON:", error);
      state.Brokers = [];
    }
  },
  UPDATE_Country(state, Property) {
    debugger
    const PropertyIndex = state.countries.findIndex((p) => p.ID == Property.Id)
    Object.assign(state.Propertys[PropertyIndex], Property)
  },
  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.Brokers.findIndex((p) => p.ID == itemId)
      state.Brokers.splice(ItemIndex, 1)
  },
}
